type PeriodDisplayTerms = {
	full: 'Quarter' | 'Period'
	short: 'Q' | 'P'
}

export function getPeriodDisplayTerms(numPeriods: number | null | undefined): PeriodDisplayTerms {
	return (!numPeriods || numPeriods === 4)
		? { full: 'Quarter', short: 'Q' }
		: { full: 'Period', short: 'P' }
}

export function formatPeriodNumber(period: number, numPeriods: number | null | undefined) {
	return `${getPeriodDisplayTerms(numPeriods).short}${period}`
}

export function formatPeriodIndex(periodIndex: number, numPeriods: number | null | undefined) {
	return formatPeriodNumber(periodIndex + 1, numPeriods)
}

export function formatFinalOrPeriodIndex(periodIndex: number, numPeriods: number | null | undefined) {
	return numPeriods && periodIndex === numPeriods - 1
		? 'Final'
		: formatPeriodIndex(periodIndex, numPeriods)
}
